export enum bahai_preferredlanguage {
  Arabic = 200630009,
  Chinese = 200630005,
  English = 200630000,
  Farsi = 200630004,
  French = 200630007,
  German = 200630003,
  Hindi = 200630012,
  Korean = 200630011,
  OtherLanguage = 200630014,
  Portuguese = 200630013,
  Russian = 200630010,
  Spanish = 200630001,
  Swahili = 200630002,
  Tagalog = 200630006,
  Vietnamese = 200630008,
}

export enum AccessRights {
  None = 0,
  ReadAccess = 1,
  WriteAccess = 2,
  AppendAccess = 4,
  AppendToAccess = 16,
  CreateAccess = 32,
  DeleteAccess = 65536,
  ShareAccess = 262144,
  AssignAccess = 524288,
}
